import React, { FC } from 'react'

import { IconButton, Typography, useTheme } from '@mui/material'
import TableCell from '@mui/material/TableCell'
import { useTranslation } from 'react-i18next'

import { ReactComponent as TradeInfoIcon } from '../../assets/icons/trade-info.svg'
import { UserService } from '../../user'
import { downloadImage } from '../../utils'
import { showToast } from '../Toasts'

import { SharingFeatureProps } from './types'

export const SharingFeatureCell: FC<SharingFeatureProps> = ({ id, logEntry }) => {
  const { spacing, palette } = useTheme()
  const { t } = useTranslation()

  const generateSharedImage = async () => {
    try {
      const { data } = await UserService.generateSharedImage({ tradeId: id })

      if (data) {
        downloadImage(data.image, `Ticket_${logEntry.ticket}.jpeg`)
      }
    } catch (error) {
      showToast.error(error.message)
    }
  }

  return (
    <TableCell
      sx={{
        fontSize: 14,
        fontWeight: 500,
        textAlign: 'right',
        padding: spacing(1.25),
        textTransform: 'capitalize',
        minWidth: spacing(10),
      }}
    >
      <IconButton
        className={`share ${!logEntry.closeTime ? 'hidden' : ''}`}
        onClick={generateSharedImage}
        disableRipple
        sx={{
          padding: 0,
          minWidth: spacing(7.5),
          height: spacing(2.5),
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 20,
          border: `1px solid ${palette.blue[500]}`,
        }}
      >
        <TradeInfoIcon style={{ marginLeft: spacing(-0.5) }} />
        <Typography
          variant="body1"
          sx={{
            color: palette.blue[500],
            fontSize: 12,
            fontWeight: 900,
            fontFamily: 'Wix Madefor Display',
          }}
        >
          {t('jpeg', 'JPEG')}
        </Typography>
      </IconButton>
    </TableCell>
  )
}
